import {
	RavenInputField,
	RavenModal,
	RavenTextTrim,
	toast,
} from '@ravenpay/raven-bank-ui';
import React, { useEffect, useState } from 'react';
import '../styles/index.css';
import { useDispatch, useSelector } from 'react-redux';
import RootState from '../../../../../redux/types';
import {
	ADMIN_OWNER_LIST,
	capitalizeFirstLetter,
	formatDateTwo,
	reactSelectStyle,
} from '../../../../../utils/helper/Helper';
import { bankboxAPI } from '../../../../../redux/bankbox';
import { validateEmail } from '../../../../../utils/helper/ValidateInput';

interface MyComponentProps {
	visible?: boolean;
	onClose?: () => void;
	onFinish?: () => void;
	detail?: any;
}

const AddTeamMemberToRoleModal: React.FC<MyComponentProps> = ({
	onClose,
	onFinish,
	visible,
}) => {
	const { roles, loading_fee, single_role, policies, teams } = useSelector(
		(state: RootState) => state.bankbox
	);
	const [selectedDays, setSelectedDay] = useState<string[]>([]);
	const [activeItem, setActiveItem] = useState<any>({
		name: 'Existing Team Member',
		link: '',
	});

	const dispatch = useDispatch();
	interface formComponent {
		email: string;
		first_name: string;
		last_name: string;
		role: any;
	}
	const [userSelected, setSelectedUser] = useState<any>('');
	const [details, setDetails] = useState<formComponent>({
		email: '',
		first_name: '',
		last_name: '',
		role: '',
	});
	// const dispatch = useDispatch()

	const handleChange = (e: any) => {
		showError && setShowError(false);
		const { name, value } = e.target;
		const obj = { ...details, [name]: value };
		setDetails(obj);
	};

	// const formatState = (param: any) => {
	// 	if (param?.length > 0) {
	// 		const newList = param?.map((chi: any) => {
	// 			return { label: chi, value: chi };
	// 		});
	// 		return newList;
	// 	}
	// };

	const [showError, setShowError] = useState<boolean>(false);
	const [loading, setLoading] = useState(false);
	const handleSubmit = async () => {
		if (!validateEmail(details?.email)) {
			toast.error('Invalid email address!', {
				position: 'top-right',
			});
			setShowError(true);
			return;
		}
		const obj = {
			...details,
			role: details?.role?.label,
		};
		// //(obj);
		// return;
		setLoading(true);
		// //(obj);
		const data = await dispatch(bankboxAPI.inviteTeamMember(obj as any));
		// //(data);

		if (data?.payload?.status === 'success') {
			setLoading(false);

			onFinish && onFinish();
			handleClose();
		} else {
			setLoading(false);
		}
	};

	const handleSubmitExist = async () => {
		if (!validateEmail(userSelected?.email)) {
			toast.error('Invalid email address!', {
				position: 'top-right',
			});
			setShowError(true);
			return;
		}
		const obj = {
			role: details?.role?.label,
			id: String(userSelected?.id),
		};
		// //(obj);
		// return;
		setLoading(true);
		// //(obj);
		const data = await dispatch(bankboxAPI.manageTeamMember(obj as any));
		// //(data);

		if (data?.payload?.status === 'success') {
			setLoading(false);
			dispatch(bankboxAPI?.getRoles({}));
			onFinish && onFinish();
			if (userSelected?.invitation_Status === 'Pending') {
				const obj = {
					email: userSelected?.email,
					dont_toast: true,
				};
				dispatch(bankboxAPI.resendTeamInvite(obj as any));
			}

			handleClose();
		} else {
			setLoading(false);
		}
	};

	const formatRoleOption = (param: any) => {
		if (param?.length > 0) {
			const newList = param?.map((chi: any) => {
				return {
					...chi,
					label: capitalizeFirstLetter(chi?.roleName),
					value: chi?.roleName,
				};
			});
			const arrAylist = newList?.filter((ch: any) => ch?.value !== 'owner');
			return arrAylist;
		}
	};

	const handleClose = () => {
		setDetails({ email: '', first_name: '', last_name: '', role: '' });
		onClose && onClose();
		// onFinish && onFinish();
		setSelectedUser('');
		setActiveItem({
			name: 'Existing Team Member',
			link: '',
		});
	};

	const settingRoutesList = [
		{
			name: 'Existing Team Member',
			link: '',
			active: activeItem?.name === 'Existing Team Member',
		},
		{
			name: 'New Team Member',
			link: '',
			active: activeItem?.name === 'New Team Member',
		},
	];

	const roleInfo = single_role ? single_role[0] : {};

	const getFormattedUsers = () => {
		if (teams?.data?.length > 0) {
			const filterList = teams?.data?.filter(
				(chi: any) => !ADMIN_OWNER_LIST?.includes(chi?.role)
			);
			const newList = filterList?.map((chi: any) => {
				return {
					...chi,
					label: `${chi?.first_name || ''} ${chi?.last_name || ''}`,
					value: chi?.id,
				};
			});
			return newList;
		}
	};

	useEffect(() => {
		if (visible && Object?.keys(roleInfo)?.length > 0) {
			const obj = {
				...roleInfo,
				label: capitalizeFirstLetter(roleInfo?.roleName),
				value: roleInfo?.roleId,
			};
			setDetails((prev) => {
				return { ...prev, role: obj };
			});
		}
	}, [visible, single_role]);

	return (
		<RavenModal
			onBtnClick={() => {
				activeItem?.name === 'Existing Team Member'
					? handleSubmitExist()
					: handleSubmit();
			}}
			btnLabel={`Add Member to ${
				RavenTextTrim(details?.role?.label, 15) || ''
			} ${details?.role?.label?.toLowerCase()?.includes('role') ? '' : 'Role'}`}
			btnColor="deep-green-light"
			onClose={() => {
				onClose && handleClose();
			}}
			loading={loading}
			disabled={
				activeItem?.name === 'Existing Team Member'
					? !userSelected || !details?.role
					: !details?.email ||
					  !details?.first_name ||
					  !details?.last_name ||
					  !details?.role
			}
			visble={visible}
			className={`session-expired-wrap-modal`}
		>
			<div
				// onClick={() => {
				// 	//(getFormattedUsers());
				// 	//(teams);
				// }}
				className="add-location-modal-index-wrap"
			>
				<div className="title-text-box">
					<p className="title">Add Team Member to Role</p>
					<p className="text grey-white-color">
						{`Add a team member to role ( ${details?.role?.label || ''} ).`}
					</p>
				</div>
				{/* route path box start */}
				<div className="route-path-wrap-box border-theme-bottom">
					{settingRoutesList?.map((chi, idx) => {
						return (
							<div
								className={`item-row ${chi?.active && 'item-row-active'}`}
								key={idx}
								onClick={() => {
									if (chi?.name !== activeItem?.name) {
										setActiveItem(chi);
										setDetails((prev) => {
											return {
												...prev,
												email: '',
												first_name: '',
												last_name: '',
											};
										});
										setSelectedUser('');
									}
								}}
							>
								<p className="name grey-white-color">{chi?.name}</p>
							</div>
						);
					})}
				</div>
				{/* route path box end */}
				{/* form box styart */}
				<div className="form-box">
					{/* select content here start */}
					{activeItem?.name === 'Existing Team Member' ? (
						<>
							{' '}
							<form
								style={{ position: 'relative', zIndex: '10', width: '100%' }}
								autoComplete="off"
								action=""
							>
								<RavenInputField
									selectStyles={reactSelectStyle}
									color="deep-green-light"
									label="Select User *"
									type="select"
									placeholder="Select Role"
									value={userSelected}
									// disabled
									menuPlacement={`top`}
									onChange={(e: any) => {
										setSelectedUser(e);
									}}
									selectOption={getFormattedUsers()}
								/>
							</form>
						</>
					) : (
						<>
							{' '}
							{/* two group start */}
							<div
								style={{ position: 'relative', zIndex: 10 }}
								className="two-group-box"
							>
								<form autoComplete="off" style={{ width: '100%' }} action="">
									<RavenInputField
										color="deep-green-light"
										label="First name * "
										type="text"
										placeholder="Enter First name"
										value={details?.first_name}
										name={`first_name`}
										onChange={handleChange}
										capitalize
									/>
								</form>
								<form autoComplete="off" style={{ width: '100%' }} action="">
									{' '}
									<RavenInputField
										color="deep-green-light"
										label="Last name * "
										type="text"
										placeholder="Enter last name"
										value={details?.last_name}
										name={`last_name`}
										onChange={handleChange}
									/>
								</form>
							</div>
							{/* two group end */}
							<RavenInputField
								color="deep-green-light"
								label="Email"
								type="text"
								placeholder="Address"
								value={details?.email}
								onChange={handleChange}
								name={`email`}
								showError={showError}
							/>
						</>
					)}
					{/* select content here end */}

					<form
						style={{ position: 'relative', zIndex: '10', width: '100%' }}
						autoComplete="off"
						action=""
					>
						<RavenInputField
							selectStyles={reactSelectStyle}
							color="deep-green-light"
							label="Role * "
							type="select"
							placeholder="Select Role"
							value={details?.role}
							disabled
							menuPlacement={`top`}
							onChange={(e: any) => {
								setDetails((prev) => {
									return { ...prev, role: e };
								});
							}}
							selectOption={formatRoleOption(roles)}
						/>
					</form>
				</div>
				{/* form box end */}
			</div>
		</RavenModal>
	);
};

export default AddTeamMemberToRoleModal;
